import { render, staticRenderFns } from "./TurnOnOverdue.vue?vue&type=template&id=646eb743"
import script from "./TurnOnOverdue.vue?vue&type=script&lang=js"
export * from "./TurnOnOverdue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports